import React from 'react';
import {
  Box,
  Typography,
  Avatar,
  Card,
  List,
  ListItemButton,
  Divider,
} from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { Link, useLocation } from 'react-router-dom';
import getUserDisplayName from '../utils/getUserDisplayName';

export default function TopContributorSidebar({ contributors = [] }) {
  const location = useLocation();
  if (contributors.length === 0) return null;

  return (
    <Card variant="outlined" sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, ml: 2 }}>
        <EmojiEventsIcon fontSize="small" color="success" sx={{ mr: 1 }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
          Top Contributors
        </Typography>
      </Box>
      <List disablePadding>
        {contributors.map((user, idx) => (
          <React.Fragment key={user.id}>
            <ListItemButton
              component={Link}
              to={`/community/user/${encodeURIComponent(
                getUserDisplayName(user)
              )}`}
              state={{ from: location.pathname }}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                py: 1,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2" sx={{ width: 16 }}>
                  #{idx + 1}
                </Typography>
                <Avatar
                  src={user.avatar || undefined}
                  alt={user.display_name || user.username}
                  sx={{ width: 24, height: 24 }}
                >
                  {!user.avatar && (user.display_name || user.username)?.[0]}
                </Avatar>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {user.display_name || user.username}
                </Typography>
              </Box>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {user.contribution_count}
              </Typography>
            </ListItemButton>
            {idx !== contributors.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>
    </Card>
  );
}
